import { render, staticRenderFns } from "./ProgramManager.vue?vue&type=template&id=9e89023a&scoped=true"
import script from "./ProgramManager.vue?vue&type=script&lang=ts"
export * from "./ProgramManager.vue?vue&type=script&lang=ts"
import style0 from "./ProgramManager.vue?vue&type=style&index=0&id=9e89023a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e89023a",
  null
  
)

export default component.exports